<div class="form-field-container" [ngClass]="{ 'selected': isSelected }" [ngStyle]="fieldStyle" (click)="onFieldClick($event)">
	@switch (config.type) {
		@case (FormFieldType.TEXT) {
			<input type="text"
				   class="form-control form-field-input input extra-small"
				   [attr.data-test-id]="'formField_' + config.id"
				   style="height: inherit; width: inherit; top: inherit; left: inherit"
				   [attr.tabindex]="config.tabIndex"
				   [title]="config.name || ''"
				   [(ngModel)]="value"
				   (ngModelChange)="onModelChange($event)"/>
		}
		@case (FormFieldType.TEXTAREA) {
			<textarea class="form-control form-field-input input extra-small"
					  style="height: inherit; width: inherit; top: inherit; left: inherit"
					  [attr.data-test-id]="'formField_' + config.id"
					  [attr.tabindex]="config.tabIndex"
					  [title]="config.name || ''"
					  [placeholder]="config.name || ''"
					  [(ngModel)]="value"
					  (ngModelChange)="onModelChange($event)"></textarea>
		}
		@case (FormFieldType.SELECTION) {
			<select class="form-control form-field-input input extra-small mat-select"
					style="height: inherit; width: inherit; top: inherit; left: inherit"
					[attr.data-test-id]="'formField_' + config.id"
					[attr.tabindex]="config.tabIndex"
					[title]="config.name || ''"
					[(ngModel)]="value"
					(ngModelChange)="onModelChange($event)">
				<option [ngValue]="null" disabled hidden>Select...</option>
				@for (option of sortedOptions || []; track option.id) {
					<option [value]="option.id">{{ option.label }}</option>
				}
			</select>
		}
		@case (FormFieldType.MULTI_SELECTION) {
			<select
				class="form-control form-field-input input extra-small mat-select"
				style="height: inherit; width: inherit; top: inherit; left: inherit"
				[attr.data-test-id]="'formField_' + config.id"
				[attr.tabindex]="config.tabIndex"
				[title]="config.name || ''"
				[(ngModel)]="value"
				(ngModelChange)="onModelChange($event)">
				<option [ngValue]="null" disabled hidden>Multi Select...</option>
				@for (option of sortedOptions || []; track option.id) {
					<option [value]="option.id">{{ option.label }}</option>
				}
			</select>
		}
		@case (FormFieldType.DATE) {
			<div class="input-wrapper">
				<input type="date"
					   class="form-control form-field-input input extra-small"
					   [attr.data-test-id]="'formField_' + config.id"
					   [attr.tabindex]="config.tabIndex"
					   [title]="config.name || ''"
					   [(ngModel)]="value"
					   (ngModelChange)="onModelChange($event)"/>
			</div>
		}
		@case (FormFieldType.TIME) {
			<div class="input-wrapper">
				<input type="time"
					   class="form-control form-field-input input extra-small"
					   [attr.data-test-id]="'formField_' + config.id"
					   [ngStyle]="{
							'top': config.top + 'px',
							'left':  config.left + 'px',
							'width': config.width + 'px',
							'height': config.height + 'px',
					   }"
					   [attr.tabindex]="config.tabIndex"
					   [title]="config.name || ''"
					   [(ngModel)]="value"
					   (ngModelChange)="onModelChange($event)"/>
			</div>
		}
		@case (FormFieldType.CHECKBOX) {
			<div class="input-wrapper">
				<label class="checkbox-label">
					<input type="checkbox"
						   class="checkbox"
						   [attr.data-test-id]="'formField_' + config.id"
						   [attr.tabindex]="config.tabIndex"
						   [title]="config.name || ''"
						   [(ngModel)]="value"
						   (ngModelChange)="onModelChange($event)"/>
				</label>
			</div>
		}
		@case (FormFieldType.NUMBER_STEPPER) {
			<div class="input-wrapper">
				<input type="number"
					   class="form-control form-field-input input extra-small number-stepper"
					   [attr.data-test-id]="'formField_' + config.id"
					   [ngStyle]="{
							'top': config.top + 'px',
							'left':  config.left + 'px',
							'width': config.width + 'px',
							'height': config.height + 'px',
					   }"
					   style="height: inherit; width: inherit; top: inherit; left: inherit"
					   [attr.tabindex]="config.tabIndex"
					   [title]="config.name || ''"
					   [step]="0.01" [min]="-999999" [max]="999999"
					   [(ngModel)]="value"
					   (ngModelChange)="onModelChange($event)"/>
			</div>
		}
		@case (FormFieldType.RADIO) {
			<div class="input-wrapper radio-group"
				 [attr.data-test-id]="'formField_' + config.id"
				 style="height: inherit; width: inherit; top: inherit; left: inherit">
				@for (option of sortedOptions || []; track option.id) {
					<label class="radio-label">
						<input type="radio"
							   [id]="option.id"
							   class="radio"
							   [name]="'radio_' + config.id"
							   [value]="option.id"
							   [tabindex]="config.tabIndex"
							   [title]="config.name || ''"
							   [(ngModel)]="value"
							   (ngModelChange)="onModelChange($event)"/>
						<span>{{ option.label }}</span>
					</label>
				}
			</div>
		}
	}
</div>
